// extracted by mini-css-extract-plugin
export var avatarContainer = "_di-0";
export var avatarTypingWave = "_di-i";
export var gray = "_di-f";
export var green = "_di-c";
export var icon = "_di-9";
export var image = "_di-1";
export var lg = "_di-6";
export var md = "_di-5";
export var presenceDot = "_di-b";
export var red = "_di-d";
export var sm = "_di-4";
export var status = "_di-a";
export var typingDot = "_di-h";
export var typingPill = "_di-g";
export var xl = "_di-7";
export var xs = "_di-3";
export var xxl = "_di-8";
export var xxs = "_di-2";
export var yellow = "_di-e";